:host {
	font-family: monospace;
	display: inline;
	overflow-wrap: anywhere;
	white-space: pre-wrap;
}
:host[hidden] {
	display: none;
}

:host(.string) {
	font-weight: var(--smoothly-display-json-string-font-weight, bold);
	color: rgb(var(--smoothly-display-json-string, var(--smoothly-primary-color)));
}
:host(.number) {
	font-weight: var(--smoothly-display-json-number-font-weight, bold);
	color: rgb(var(--smoothly-display-json-number, var(--smoothly-secondary-color)));
}
:host(.boolean) {
	font-weight: var(--smoothly-display-json-boolean-font-weight, bold);
	color: rgb(var(--smoothly-display-json-boolean, var(--smoothly-tertiary-color)));
}
:host(.null),
:host(.undefined) {
	font-weight: var(--smoothly-display-json-undefined-font-weight, normal);
	color: rgb(var(--smoothly-display-json-undefined, var(--smoothly-medium-color)));
}
